const DONE_STATUSES = ['CANCELLED', 'DONE', 'DONE_WITHOUT_MANIFEST', 'DONE_WITH_CANCELLATIONS'];

const shipmentStatusScores = {
  ASSIGNED: 1,
  ONROUTE: 2,
  ONROUTE_PICKUP: 2,
  ONROUTE_DROPOFF: 2,
  PENDING: 3,
  PENDING_PICKUP: 3,
  PENDING_DROPOFF: 3,
  LOADED: 4,
  DELIVERED: 4,
  DONE: 4,
};

const getMaxOfScoresOfShipments = (shipments = {}) =>
  Object.values(shipments).reduce(
    (score, status) => Math.max(score, shipmentStatusScores[status] || 0),
    0
  );

const calculateStopScore = (status, shipments) => {
  if (DONE_STATUSES.includes(status)) {
    return 99;
  }

  if (['IN_PROGRESS'].includes(status)) {
    return getMaxOfScoresOfShipments(shipments);
  }

  return 0;
};

const calculateStageScore = (stage) => shipmentStatusScores[stage];

export { calculateStopScore, calculateStageScore, shipmentStatusScores, DONE_STATUSES };
